import React from 'react';
import ServiceLandingPage from './ServiceLandingPage';
import cuidadorasImg from '../../assets/cuidadoras.jpg';

const CuidadosGeriatricos = () => {
  const pageData = {
    title: "Cuidados Geriátricos",
    metaDescription: "Servicios especializados de cuidados geriátricos a domicilio en Guadalajara. Atención integral para adultos mayores con personal capacitado.",
    heroTitle: "Cuidados Geriátricos Especializados",
    heroSubtitle: "Atención integral y personalizada para adultos mayores en la comodidad de su hogar",
    description: "Nuestro servicio de cuidados geriátricos está especialmente diseñado para atender las necesidades únicas de los adultos mayores. Combinamos atención médica profesional con el calor humano y la paciencia que nuestros mayores merecen, promoviendo su bienestar físico, emocional y social.",
    benefits: [
      "Atención especializada en geriatría",
      "Estimulación cognitiva y prevención de deterioro",
      "Acompañamiento emocional y compañía",
      "Asistencia en actividades de la vida diaria",
      "Prevención y manejo de caídas",
      "Control de enfermedades crónicas",
      "Coordinación de citas médicas",
      "Fomento de la autonomía y dignidad"
    ],
    features: [
      {
        title: "Evaluación Geriátrica",
        description: "Valoración integral inicial para crear un plan de cuidados personalizado"
      },
      {
        title: "Estimulación Cognitiva",
        description: "Ejercicios y actividades para mantener activa la mente y prevenir deterioro"
      },
      {
        title: "Movilidad y Ejercicio",
        description: "Rutinas adaptadas para mantener la fuerza y prevenir caídas"
      },
      {
        title: "Nutrición Especializada",
        description: "Supervisión de dietas específicas para adultos mayores"
      },
      {
        title: "Manejo de Medicamentos",
        description: "Administración correcta y puntual de tratamientos múltiples"
      },
      {
        title: "Apoyo Emocional",
        description: "Compañía y contención para combatir la soledad y depresión"
      }
    ],
    faqs: [
      {
        question: "¿Qué diferencia hay entre una cuidadora y una enfermera geriátrica?",
        answer: "La cuidadora brinda asistencia en actividades diarias y compañía. La enfermera geriátrica además puede realizar procedimientos médicos, administrar medicamentos inyectables y dar seguimiento clínico especializado."
      },
      {
        question: "¿Atienden pacientes con Alzheimer o demencia?",
        answer: "Sí, contamos con personal especializado en el cuidado de pacientes con deterioro cognitivo, Alzheimer y otros tipos de demencia. Aplicamos técnicas de comunicación y manejo específicas."
      },
      {
        question: "¿Pueden ayudar con la movilidad del adulto mayor?",
        answer: "Por supuesto. Nuestro personal está capacitado en técnicas de transferencia segura, uso de andaderas, sillas de ruedas y apoyo para caminar."
      },
      {
        question: "¿Ofrecen servicio por horas o solo turnos completos?",
        answer: "Ofrecemos ambas modalidades: turnos de 6, 8, 12 o 24 horas según las necesidades de cada familia."
      }
    ],
    image: cuidadorasImg,
    relatedBlogSlugs: ['cuidados-geriatricos-zapopan', 'como-elegir-enfermera-domicilio']
  };

  return <ServiceLandingPage {...pageData} />;
};

export default CuidadosGeriatricos;
